export default __webpack_public_path__ + "static/media/ic_matic_24.75c61124.svg";